import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({
  name: 'pipeFunction',
  standalone: true,
})
export class PipeFunction implements PipeTransform {
  public transform(
    value: unknown | any,
    handler: (value: any) => any,
    context?: unknown | any
  ): any {
    if (context) {
      return handler.call(context, value);
    }

    return handler(value);
  }
}
